// extracted by mini-css-extract-plugin
export default {"withCenter":"WithCenter-module__withCenter--i2YNl"};